import OptimizeTest from './OptimizeTest'
import { LoadedTests } from './testConfig'

/**
 * Hopefully Google doesn't change any of these constants, but if we ever have trouble with
 * Optimize tests, it could be because of this.
 */

const GOOGLE_OPTIMIZE_GAX_VERSION_REGEX = /^GA(X?)(\d?)(\.\d)?(\.?)/i
const GOOGLE_OPTIMIZE_TEST_SEPARATOR = '!'
const GOOGLE_OPTIMIZE_PROPERTY_SEPARATOR = '.'

/**
 * Given a string (from the GO cookie), try to clean it and then break it apart into multiple
 * OptimizeTest objects. This is relatively brittle because of the assumptions made in
 * the constants above.
 */

export default function parseOptimizeCookie(
  optimizeCookie: string,
): LoadedTests {
  const cookieString = optimizeCookie || ''

  const testsFromCookie = getTestsFromCookie(cookieString)
  const testsLoaded: LoadedTests = {}

  testsFromCookie.forEach(test => {
    const maybeTest = buildTestIfValid(test)

    if (maybeTest instanceof OptimizeTest) {
      testsLoaded[maybeTest.id] = maybeTest
    }
  })

  return testsLoaded
}

function getTestsFromCookie(gaCookie: string): string[] {
  const testsInCookie = removeGaxFromCookie(gaCookie)
  return splitTestsInCookie(testsInCookie)
}

function removeGaxFromCookie(gaCookie: string): string {
  return gaCookie.replace(GOOGLE_OPTIMIZE_GAX_VERSION_REGEX, '')
}

function splitTestsInCookie(tests: string): string[] {
  const result = tests.split(GOOGLE_OPTIMIZE_TEST_SEPARATOR)

  // 🤦
  if (result.length === 1 && result[0] === '') {
    return []
  }

  return result
}

function buildTestIfValid(test: string): OptimizeTest | void {
  const testProps = test.split(GOOGLE_OPTIMIZE_PROPERTY_SEPARATOR)

  const id = testProps[0]
  const variant = testProps[2]

  let expiration = Number(testProps[1])

  if (expiration === 0) {
    // Rationale: if GO provides no expiration, we assume the test never expires.
    expiration = Number.POSITIVE_INFINITY
  }

  // @TODO: the OptimizeTest constructor should handle missing IDs
  if (id.trim() !== '') {
    return new OptimizeTest(id, Number(expiration), variant)
  }
}
